import { AverageDailyRateDataBuilder } from './adr-chart';
import { CurrentStrPropertiesDataBuilder } from './current-str-properties-chart';
import { OccupancyDataBuilder } from './occupancy-chart';
import { OnlinePlatformsDataBuilder } from './online-platforms-chart';
import { RentalSizeDataBuilder } from './rental-size-chart';
import { RentalStructureDataBuilder } from './rental-structure-chart';
import { UnitTypeDataBuilder } from './rental-type-chart';
import { ResidentialTypeDataBuilder } from './residential-type-chart';
import { RevenueDataBuilder } from './revenue-chart';
import { TOTDataBuilder } from './tot-chart';

const chartToDataBuilder = {
  CurrentStrPropertiesChart: CurrentStrPropertiesDataBuilder,
  OccupancyChart: OccupancyDataBuilder,
  RevenueChart: RevenueDataBuilder,
  AverageDailyRateChart: AverageDailyRateDataBuilder,
  TransientOccupancyTaxChart: TOTDataBuilder,
  OnlinePlatformsChart: OnlinePlatformsDataBuilder,
  ResidentialTypeChart: ResidentialTypeDataBuilder,
  RentalStructureChart: RentalStructureDataBuilder,
  RentalSizeChart: RentalSizeDataBuilder,
  RentalTypeChart: UnitTypeDataBuilder,
};

function chartDataFactory(chartName, data) {
  const ChartDataBuilder = chartToDataBuilder[chartName];
  if (!ChartDataBuilder) return null;
  const chartData = new ChartDataBuilder(data).retrieveDatasets;
  return chartData;
}

export { chartDataFactory };
